import React from 'react'

export function useModalHandler () {
  const [isOpen, setIsOpen] = React.useState(false)
  const openModal = React.useCallback(() => setIsOpen(true), [setIsOpen])
  const closeModal = React.useCallback(() => setIsOpen(false), [setIsOpen])
  return React.useMemo(() => [isOpen, openModal, closeModal], [isOpen, openModal, closeModal])
}
